module.exports = __webpack_public_path__ + "img/new-year.961d5375.png";